module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.callbackFlag) ? _c('div', {
    staticClass: "wrapper pt-header65"
  }, [_c('header', {
    staticClass: "gheader gheader-fix"
  }, [_c('div', {
    staticClass: "gheader__link-back"
  }, [_c('a', {
    on: {
      "click": _vm.goMoralStart
    }
  }, [_vm._v("戻る")])]), _c('button', {
    staticClass: "gheader__start-btn btn01",
    on: {
      "click": _vm.goMoralCheck
    }
  }, [_c('span', [_vm._v("チェックをはじめる")])])]), _vm._m(0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container moral-tebiki bg03"
  }, [_c('h1', {
    staticClass: "fz20 bold mb25 txtC brown"
  }, [_vm._v("モラル確認の手引き")]), _c('div', {
    staticClass: "moral-tebiki__sec"
  }, [_c('h2', {
    staticClass: "fz18 bold mb10 brown"
  }, [_vm._v("■反社会行動")]), _c('dl', [_c('dt', {
    staticClass: "fz15 brown",
    staticStyle: {
      "font-weight": "normal",
      "margin-bottom": "0px"
    }
  }, [_vm._v("・道路交通法違反")]), _c('dd', [_c('span', {
    staticClass: "fz14 brown"
  }, [_vm._v("アテンダントマニュアルP37 『社員規定』参照")])]), _c('dt', {
    staticClass: "fz15 brown",
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("・迷惑防止条例違反・強制わいせつ罪(痴漢行為・盗撮行為)")]), _c('dt', {
    staticClass: "fz15 brown",
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("・窃盗罪・恐喝罪(罪のケースで第条は異なります。)")]), _c('dt', {
    staticClass: "fz15 brown",
    staticStyle: {
      "font-weight": "normal",
      "margin-bottom": "0px"
    }
  }, [_vm._v("・アテンダントマニュアルP33参照")]), _c('dd', [_c('span', {
    staticClass: "fz14 brown"
  }, [_vm._v("採用時確認事項/雇用期間遵守事項")])])])]), _c('div', {
    staticClass: "moral-tebiki__sec"
  }, [_c('h2', {
    staticClass: "fz18 bold mb10 brown"
  }, [_vm._v("■自己管理")]), _c('dl', [_c('dt', {
    staticClass: "fz15 brown",
    staticStyle: {
      "font-weight": "normal",
      "margin-bottom": "0px"
    }
  }, [_vm._v("・予防保全として勤務への支障対策を施せる能力がある事！")])])]), _c('div', {
    staticClass: "moral-tebiki__sec"
  }, [_c('h2', {
    staticClass: "fz18 bold mb10 brown"
  }, [_vm._v("■就業規則確認")]), _c('dl', [_c('dt', {
    staticClass: "fz15 brown",
    staticStyle: {
      "font-weight": "normal",
      "margin-bottom": "0px"
    }
  }, [_vm._v("・就業規則")]), _c('dd', [_c('span', {
    staticClass: "fz14 brown"
  }, [_vm._v("アテンダントマニュアルP37『社員規定』参照"), _c('br'), _vm._v("・採用時説明事項")])])])]), _c('div', {
    staticClass: "moral-tebiki__sec"
  }, [_c('h2', {
    staticClass: "fz18 bold mb10 brown"
  }, [_vm._v("■採用時確認事項")]), _c('dl', [_c('dt', {
    staticClass: "fz15 brown",
    staticStyle: {
      "font-weight": "normal",
      "margin-bottom": "0px"
    }
  }, [_vm._v("・雇用期間遵守事項・就業規則確認")])])]), _c('div', {
    staticClass: "moral-tebiki__sec"
  }, [_c('h2', {
    staticClass: "fz18 bold mb10 brown"
  }, [_vm._v("■就業規則・法令遵守")]), _c('dl', [_c('dt', {
    staticClass: "fz15 brown",
    staticStyle: {
      "font-weight": "normal",
      "margin-bottom": "0px"
    }
  }, [_vm._v("・風俗営業における確認事項・社員間トラブル")])])]), _c('div', {
    staticClass: "moral-tebiki__sec"
  }, [_c('h2', {
    staticClass: "fz18 bold mb10 brown"
  }, [_vm._v("■社員間トラブル")]), _c('dl', [_c('dt', {
    staticClass: "fz15 brown",
    staticStyle: {
      "font-weight": "normal",
      "margin-bottom": "0px"
    }
  }, [_vm._v("・アテンダントマニュアルP37『社員規定』参照")]), _c('dd', [_c('span', {
    staticClass: "fz14 brown"
  }, [_vm._v("社会的には、恋愛は自由です。しかし、社内恋愛による２人の行動が社の風紀をはじめとした店舗内に齎らす負の影響を考えて頂ければ幸いです。また、恋愛関係になった場合には、所属長への報告を行い、誠実な交際をお願いします。")])])])]), _c('div', {
    staticClass: "moral-tebiki__sec"
  }, [_c('h2', {
    staticClass: "fz18 bold mb10 brown"
  }, [_vm._v("■対人マナー")]), _c('dl', [_c('dt', {
    staticClass: "fz15 brown",
    staticStyle: {
      "font-weight": "normal",
      "margin-bottom": "0px"
    }
  }, [_vm._v("・セクシャルハラスメント")]), _c('dd', [_c('span', {
    staticClass: "fz14 brown"
  }, [_vm._v("「労働者」の意に反する「性的言動」 （男女雇用機会均等法）")])]), _c('dt', {
    staticClass: "fz15 brown",
    staticStyle: {
      "font-weight": "normal",
      "margin-bottom": "0px"
    }
  }, [_vm._v("・パワーハラスメント")]), _c('dd', [_c('span', {
    staticClass: "fz14 brown"
  }, [_vm._v("職務上の地位や人間関係の優位性を背景に適正な業務範囲を超えて精神・身体的苦痛を与える又は、職場環境に悪影響を与え環境を悪化させる行為。ハラスメント行為(パワハラ、セクハラ、モラハラ等、様々な場面においての嫌がらせ、いじめ。)")])])])]), _c('div', {
    staticClass: "moral-tebiki__sec"
  }, [_c('h2', {
    staticClass: "fz18 bold mb10 brown"
  }, [_vm._v("■未成年質問")]), _c('dl', [_c('dt', {
    staticClass: "fz15 brown",
    staticStyle: {
      "font-weight": "normal",
      "margin-bottom": "0px"
    }
  }, [_vm._v("・未成年飲酒禁止法・未成年喫煙禁止法(2000年改正)罰金:高額化・責任の拡大")])])]), _c('div', {
    staticClass: "moral-tebiki__sec"
  }, [_c('h2', {
    staticClass: "fz18 bold mb10 brown"
  }, [_vm._v("■モラル行動確認")]), _c('dl', [_c('dt', {
    staticClass: "fz15 brown",
    staticStyle: {
      "font-weight": "normal",
      "margin-bottom": "0px"
    }
  }, [_vm._v("・アテンダントマニュアルP25,26『社会人・プロとしての心得』参照")])])]), _c('div', {
    staticClass: "moral-tebiki__sec"
  }, [_c('h2', {
    staticClass: "fz18 bold mb10 brown"
  }, [_vm._v("■職場環境")]), _c('dl', [_c('dt', {
    staticClass: "fz15 brown",
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("・利用マナーが確立されており整理整頓清掃が行渡っており気持ちよく利用出来る。全ての社員が快適な休憩スペースであること。")]), _c('dt', {
    staticClass: "fz15 brown",
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("・上司と部下の関係において報告・連絡・相談を気軽に出来る環境が望ましく、すなわち風通し良い職場であること。")]), _c('dt', {
    staticClass: "fz15 brown",
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("・社員間において、チーム力向上に支障など発生する事なく　団結心の和が煌く環境であること。")])])]), _c('div', {
    staticClass: "moral-tebiki__sec"
  }, [_c('h2', {
    staticClass: "fz18 bold mb10 brown"
  }, [_vm._v("■企業コンプライアンス")]), _c('dl', [_c('dt', {
    staticClass: "fz15 brown",
    staticStyle: {
      "font-weight": "normal",
      "margin-bottom": "0px"
    }
  }, [_vm._v("・遵法営業に伴う正しい知識と認識が必要となります。お客様目線ではいけません！")]), _c('dd', [_c('span', {
    staticClass: "fz14 brown"
  }, [_vm._v("※お客様に提供する賞品は、原則すべて等価となります。")])]), _c('dt', {
    staticClass: "fz15 brown",
    staticStyle: {
      "font-weight": "normal",
      "margin-bottom": "0px"
    }
  }, [_vm._v("・お客様へのサービス業での営業ですが、店舗運営を行う上では、法令遵守があってこその営業となります！")]), _c('dd', [_c('span', {
    staticClass: "fz14 brown"
  }, [_vm._v("※1:パチンコ店(風営法第4号営業)では、現金への買取を推奨する事が出来ませんので買取所への御案内を控えております。")])]), _c('dd', [_c('span', {
    staticClass: "fz14 brown"
  }, [_vm._v("※2:買取業務は、一切関わりがありません。アテンダントマニュアルP36『三店方式とは』参照")])])])]), _c('div', {
    staticClass: "moral-tebiki__sec"
  }, [_c('h2', {
    staticClass: "fz18 bold mb10 brown"
  }, [_vm._v("■知識確認")]), _c('dl', [_c('dt', {
    staticClass: "fz15 brown",
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("・安心安全の観点からの防災防火意識　電気火災時には、二酸化炭素消火器を使用します。保管場所は、ホールカウンターです。")]), _c('dt', {
    staticClass: "fz15 brown",
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("・AEDとは自動体外式除細動器の略でお客様が、突然心臓が正常に拍動できなくなった心停止状態の心臓に対して、電気ショックを行い、心臓を正常なリズムに戻すための医療機器です。")])])]), _c('div', {
    staticClass: "moral-tebiki__sec"
  }, [_c('h2', {
    staticClass: "fz18 bold mb10 brown"
  }, [_vm._v("■モラル行動確認")]), _c('dl', [_c('dt', {
    staticClass: "fz15 brown",
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("・我々の社業は接客業であり不特定多数のお客様に認知されております。よって集団行動となると認知の度合いが倍増し行動に自制心の要求が個人より大きく求められるケースがあるからです。")]), _c('dt', {
    staticClass: "fz15 brown",
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("・アテンダントマニュアルP37『社員規定』SNSの利用規定参照")])])]), _c('div', {
    staticClass: "moral-tebiki__sec"
  }, [_c('h2', {
    staticClass: "fz18 bold mb10 brown"
  }, [_vm._v("■ルール行動確認")]), _c('dl', [_c('dt', {
    staticClass: "fz15 brown",
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("・セキュリティー及びコンプライアンスの観点から勤務中の携帯電話(スマホ等)の利用をお断りしております。")]), _c('dt', {
    staticClass: "fz15 brown",
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("・社業は、公平平等を期す業態で情報漏洩や勘違い等を引き起こす原因とみなします。")])])]), _c('div', {
    staticClass: "moral-tebiki__sec"
  }, [_c('h2', {
    staticClass: "fz18 bold mb10 brown"
  }, [_vm._v("■確認意識")]), _c('dl', [_c('dt', {
    staticClass: "fz15 brown",
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("・いまいちど再確認し、意識しておく事項となります。(免許未取得者は、質問内容に対して理解の観点で応じてください。)")])])]), _c('div', {
    staticClass: "moral-tebiki__sec"
  }, [_c('h2', {
    staticClass: "fz18 bold mb10 brown"
  }, [_vm._v("■モラル他者視点")]), _c('dl', [_c('dt', {
    staticClass: "fz15 brown",
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("・ワンダーランドびとの仲間を大事にすることは正しい事であるが、倫理的観点や正義を優先させる事が最重要です。")]), _c('dt', {
    staticClass: "fz15 brown",
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("・業務内外を問わず、組織人として倫理意識(人として守るべき道。道徳)を持ち社会生活を過ごすことが出来ている事が望ましい。")])])]), _c('div', {
    staticClass: "moral-tebiki__sec"
  }, [_c('h2', {
    staticClass: "fz18 bold mb10 brown"
  }, [_vm._v("■ESmyカード")]), _c('dl', [_c('dt', {
    staticClass: "fz15 brown",
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("・毎年1月11日熱豊会にて「`ｇｏｏｄ`のあるＥＸ-Ｃｏｍｐａｎｙ」を実現する為に掲げるＷＩＬＬ（私が描く今年の抱負)とＭＵＳＴ（私が求められている事）を、エージェントカードに貼付けます。ＷＩＬＬ＆ＭＵＳＴの未記入による作成漏れを防ぎ、いつでも振り返りを行える環境を作ります。")])])]), _c('div', {
    staticClass: "moral-tebiki__sec"
  }, [_c('h2', {
    staticClass: "fz18 bold mb10 brown"
  }, [_vm._v("■憂慮の有無")]), _c('dl', [_c('dt', {
    staticClass: "fz15 brown",
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("・人間関係などで悩む事も多々あり　出来たら異動転勤して向上心を活性させたいと考える事が頻繁にある方は、“いいえ”にチェックと在籍期間を記入して下さい")])])]), _c('div', {
    staticClass: "moral-tebiki__sec"
  }, [_c('h2', {
    staticClass: "fz18 mb10",
    staticStyle: {
      "color": "#D53E62"
    }
  }, [_vm._v("類似行為や擬似行為についても、自身がもたらす行動による場合もあります。再度、自分自身の行動は、誠実に責任ある行動でお願いします。上記、事項の中でも反社会的行動には厳しい処分（法的）があると自覚しておいて下さい。"), _c('br'), _vm._v("※虚偽の報告に関しても「誠実性に欠け、信頼できない」と判断した場合は、所属長の面談を実施します。")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8b86d534!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/moral-guidance.pug
// module id = 1444
// module chunks = 1